import PropTypes from 'prop-types';

var propTypes = {
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    onDatesChange: PropTypes.func,
    calendarLocale: PropTypes.string,
    startDateLabel: PropTypes.string,
    endDateLabel: PropTypes.string,
    isStartDateInitiallyFocused: PropTypes.bool,
    firstDayOfWeek: PropTypes.number,
};
var defaultProps = {
    calendarLocale: 'en-US',
    startDate: null,
    endDate: null,
    isStartDateInitiallyFocused: false,
};

export { defaultProps, propTypes };
